/*
 * File: theme-base.ts
 * Created: 2025-12-03 12:29:26
 * Author: Val Liu <valuis0429@gmail.com>
 * -----
 * Last Modified: 2025-12-05 11:37:59
 * Modified By: Val Liu <valuis0429@gmail.com>
 */

import { Vue, Component } from "vue-property-decorator";
import DefaultContainer from "./containers/DefaultContainer.vue";

import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";
import BootstrapVue from "@valuis0429/bootstrap-vue";
import { FindRouter } from "@/../core";

Vue.use(BootstrapVue);

/**
 * 通用 ThemeBase 基底元件
 * - 負責 theme / body class
 * - 由 main.vue 使用 <Container> 排版
 * - Theme 只要繼承它，覆寫 components.Container 即可換版型
 */
@Component
export class ThemeBase extends Vue {
    themeName: string = "";

    /** 讓 main.vue 可以用 thisRouter 判斷要不要套 container 等 */
    get thisRouter() {
        const routers = FindRouter({ path: this.$route.path });
        return routers.length === 0 ? null : routers[routers.length - 1];
    }

    /** 掛載時處理 theme class */
    mounted() {
        const computed = getComputedStyle(document.body);
        // const cssThemeName = computed.getPropertyValue("--theme-name").trim();
        // const themeName = cssThemeName; // 預設 theme
        // this.console.log("theme name?", themeName)

        const regex = /^v-theme-/;
        document.body.classList.forEach((cls) => {
            if (regex.test(cls)) document.body.classList.remove(cls);
        });
        document.body.classList.add(this.themeName);
    }

    get console() {
        return console;
    }
}

export default ThemeBase;
